export const lastRun = {
    path   : '/background_process/last_run/',
    method : 'GET',
    version: '/v1'
}